import { Select } from '@mantine/core';
import React from 'react';

const BedroomsInput = ({ form }: any) => {
    return (
        <Select
            label="No. of bedrooms"
            data={["0", "1", "2", "3", "4", "5", "6", "7"]}
            sx={{ flex: 1 }}
            {...form.getInputProps(
                "noOfBedrooms"
            )}
        />
    );
};

export default BedroomsInput;